import * as React from "react";
import Modal from "../ui/modal/Modal";
import SectionView from "../layout/section/SectionView";
import Row from "../layout/Row";
import Col from "../layout/Col";
import TimePicker from "./TimePicker";
import {none, Option, option} from "ts-option";
import DatePickerComponent from "../ui/datepicker/DatePickerComponent";
import SectionSeparator from "../layout/section/SectionSeparator";
import FormButtonsView from "../ui/form/FormButtonsView";
import {LabelableProps} from "../common/props/LabelableProps";
import AppointmentType from "../../model/appointment/AppointmentType";
import DropDown from "../../hiberUiKit/src/molecules/DropDown/DropDown";
import {RootState} from "../../store/reducer/root/RootState";
import {connect} from "react-redux";
import AppointmentSalesEngineerDropdown from "../lead/v4/AppointmentSalesEngineerDropdown";
import ButtonPrimary from "../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import IndividualContact from "../../model/contact/IndividualContact";
import AppointmentUtils, {IAppointmentDuration} from "../../utils/AppointmentUtils";
import Appointment from "../../model/appointment/Appointment";
import {isDefined} from "../../utils/Utils";
import {getIndividualContact} from "../../store/view/contact";
import moment = require("moment");

interface ComponentProps {
	/**
	 *
	 */
	appointmentToEdit: Option<Appointment>
	/**
	 * On value change callback
	 * @param {Appointment} appointment
	 */
	onChange: (appointment: Appointment) => void
	/**
	 * On close action.
	 */
	onClose: () => void
	/**
	 * Lead form contact
	 */
	leadFormContactId: Option<string>;
}

interface IReduxProps {
	appointmentTypes: AppointmentType[],
	contact: Option<IndividualContact>
}

interface State {
	appointmentDateTime: moment.Moment;
	appointmentType: Option<AppointmentType>;
	appointmentSalesEngineerId: Option<string>;
	appointmentDuration: Option<number>;
}

type Props = ComponentProps & IReduxProps & LabelableProps;

class AddAppointmentModal extends React.PureComponent<Props, State> {

	durations = AppointmentUtils.getAppointmentDurations();

	constructor(props: Props) {
		super(props);
		this.state = {
			appointmentDateTime: this.props.appointmentToEdit.map(a => a.dateTime).getOrElse(moment().startOf("day")),
			appointmentType: this.props.appointmentToEdit.flatMap(a => a.type),
			appointmentSalesEngineerId: this.props.appointmentToEdit.flatMap(a => a.assigneeId),
			appointmentDuration: this.props.appointmentToEdit.map(a => a.duration)
		};
		this.handleCloseModal = this.handleCloseModal.bind(this);
		this.handleTimeChange = this.handleTimeChange.bind(this);
		this.isDurationItemDisabled = this.isDurationItemDisabled.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.handleCloseModal} title={this.props.label} autoWidth={true}>
				<SectionView>
					<Row>
						<Col>
							<DatePickerComponent value={option(this.state.appointmentDateTime)}
												 inline={true}
												 initialDate={moment()}
												 minDate={moment()}
												 customClass={"c-appointment-date-picker"}
												 onChange={(value) => this.handleDateChange(value)}/>
							<TimePicker initialDate={option(this.state.appointmentDateTime)}
										onChange={value => this.handleTimeChange(value)}
										interval={15}
										startTime={"06:00"} endTime={"22:00"}/>
						</Col>
					</Row>
					<Row>
						<Col xl={5} lg={5}>
							<div style={{width: "325px", marginTop: "15px"}}>
								<DropDown placeholder={"Duration"}
										  items={this.durations}
										  itemToId={(item: IAppointmentDuration) => `${item.minutes}`}
										  itemToLabel={(item: IAppointmentDuration) => item.displayValue}
										  selectedItemId={this.state.appointmentDuration.map(d => `${d}`).orNull}
										  onSelect={(item: IAppointmentDuration) => this.setState(
											  {appointmentDuration: option(item.minutes)})}
										  itemDisabled={this.isDurationItemDisabled}
										  disabled={!isDefined(this.state.appointmentDateTime)}
										  dropDownOnTop/>
							</div>
						</Col>
						<Col xl={7} lg={7}>
							<div style={{marginTop: "15px"}}>
								<DropDown placeholder={"Appointment type"}
										  items={this.props.appointmentTypes}
										  itemToId={(item: AppointmentType) => item.id}
										  itemToLabel={(item: AppointmentType) => item.getDisplayName()}
										  selectedItemId={this.state.appointmentType.map(at => at.id).orNull}
										  onSelect={(item: AppointmentType) => this.setState({appointmentType: option(item)})}
										  clearable
										  dropDownOnTop
										  onClearClick={() => this.setState({appointmentType: none})}
								/>
							</div>
						</Col>
					</Row>
					<Row>
						<Col xl={5} lg={5}>
							<div className={"c-appointment-se-dropdown"}>
								<AppointmentSalesEngineerDropdown
									dropDownTop
									selectedSalesEngineerId={this.state.appointmentSalesEngineerId}
									onChange={(item: string) => this.setState({appointmentSalesEngineerId: option(item)})}
									placeholder={"Select sales engineer"}
									leadPartnerBrandId={this.props.contact.flatMap(c => c.data.partnerBrandId)}/>
							</div>
						</Col>
					</Row>
					<SectionSeparator style={{margin: "30px -35px 0 -35px"}}/>
				</SectionView>
				<FormButtonsView align={"right"}>
					<div className="pull-left">
						<ButtonTertiary label="Cancel" onClick={() => this.props.onClose()}/>
					</div>
					<ButtonPrimary label={"Done"}
								   onClick={() => this.onDone()}
								   disabled={!this.state.appointmentDateTime.hours() || this.state.appointmentDuration.isEmpty}/>
				</FormButtonsView>
			</Modal>)
	}

	/**
	 * Handle close modal.
	 */
	private handleCloseModal() {
		this.props.onClose();
	}

	/**
	 * On done button click callback.
	 */
	private onDone() {
		if (this.props.appointmentToEdit.isEmpty
			|| !this.props.appointmentToEdit.get.dateTime.isSame(this.state.appointmentDateTime)
			|| this.props.appointmentToEdit.get.type.map(at => at.id).orNull !==
			this.state.appointmentType.map(at => at.id).orNull
			|| this.props.appointmentToEdit.flatMap(a => a.assigneeId).orNull !== this.state.appointmentSalesEngineerId.orNull
			|| this.props.appointmentToEdit.get.duration !== this.state.appointmentDuration.orNull
		) {
			this.props.onChange(
				this.props.appointmentToEdit.map(a =>
					a.copy({
						dateTime: this.state.appointmentDateTime,
						type: this.state.appointmentType,
						assigneeId: this.state.appointmentSalesEngineerId,
						duration: this.state.appointmentDuration.get
					})).getOrElse(Appointment.create(this.state.appointmentDateTime, this.state.appointmentType,
					this.state.appointmentSalesEngineerId, this.state.appointmentDuration.get)))
		}

		this.props.onClose();
	}

	/**
	 * Handle date change and reset time if is in past.
	 * @param {moment.Moment} appointmentDate
	 */
	handleDateChange(appointmentDate: Option<moment.Moment>) {
		let newDate = appointmentDate.map((date: moment.Moment) => {
			if (date.isBefore(moment())) {
				return date.startOf("day");
			}
			return date;
		}).getOrElse(moment().startOf("day"));
		this.setState({appointmentDateTime: newDate, appointmentDuration: none})
	}

	/**
	 * Handle time change and merge time with reminder date.
	 * @param {moment.Moment} appointmentTime
	 */
	handleTimeChange(appointmentTime: moment.Moment) {
		const appointmentDateTime = moment(this.state.appointmentDateTime).startOf("day")
			.add(appointmentTime.hours(), "hours")
			.add(appointmentTime.minutes(), "minutes");
		if (!appointmentDateTime.isSame(this.state.appointmentDateTime, "minutes")) {
			this.setState({appointmentDateTime: appointmentDateTime, appointmentDuration: none});
		}
	}

	isDurationItemDisabled(item: IAppointmentDuration) {
		return AppointmentUtils.isNextDay(option(this.state.appointmentDateTime), item.minutes)
	}
}

function mapStateToProps(state: RootState, props: ComponentProps) {
	const contact = props.leadFormContactId.flatMap(getIndividualContact);
	const appointmentTypes = state.appointment.appointmentTypes.getOrElse([]);

	return ({
		appointmentTypes,
		contact
	})
}

export default connect(mapStateToProps)(AddAppointmentModal)
